import React, { useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  OutlinedInput,
} from "@material-ui/core";
import { TextField, Button } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers"; // For date picker
import { useDispatch, useSelector } from "react-redux";

import CustomSelect from "../../../common-components/CustomSelect";
//import CustomDatePicker from "../../../common-components/CustomDatePicker";
import CustomTextField from "../../../common-components/CustomTextField";
import ActionMessages from "../../../common-components/ActionMessages";
import Loading from "../../../common-components/Loading";
import {
  getResponse,
  formatDateBySetting,
} from "../../../shared-resources/utils";
import {
  getDefaultAvailableHoursAPI,
  getFinancialYearsAPI,
  updateDefaultAvailableHoursAPI,
  addYearForDefaultHoursAPI,
} from "../../../api/admin-api";

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  table: {
    width: "100%",
    marginTop: theme.spacing(1),
    borderCollapse: "collapse",
    backgroundColor: "#e6eaeb", // Milky white background for the table
  },
  tableContainer: {
    maxHeight: 500,
    overflowY: "auto",
  },
  tableHeader: {
    backgroundColor: "#4B5558",
    color: "white",
    fontWeight: "bold",
  },
  tableCell: {
    padding: theme.spacing(1),
    textAlign: "left",
  },
  zebraRow: {
    backgroundColor: "#f5f5f5",
  },
  zebraRowDark: {
    backgroundColor: "#fff",
  },
  searchBox: {
    width: "260px",
    marginBottom: theme.spacing(2),
    display: "block",
    marginLeft: "10px", // Align search box to the left
  },
  editBtn: {
    color: "#ffff",
    border: "1px solid #3599d1",
    padding: "6px 20px !important",
    fontSize: "13px",
    borderRadius: "15px",
    textTransform: "none",
    backgroundColor: "#0176d3",
    cursor: "pointer",
  },
  cancelButton: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginLeft: "10px",
  },
  cancelBtn: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
  updateBtn: {
    color: "#ffff",
    border: "1px solid #3599d1",
    padding: "6px 20px !important",
    fontSize: "13px",
    borderRadius: "15px",
    textTransform: "none",
    backgroundColor: "#0176d3",
    cursor: "pointer",
  },
  mainContainer: {
    backgroundColor: "#fff",
    justifyContent: "center",
    display: "flex",
    padding: "15px",
    flexDirection: "column",
    borderRadius: "10px",
  },
  createBtn: {
    fontSize: "12px",
    padding: "4px 8px !important",
    textTransform: "none",
    background: "#0176D3",
    marginLeft: "8px",
  },

  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
    fontSize: "13px",
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  addDialog: {
    width: "350px",
    height: "auto",
    position: "relative",
  },
  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  saveBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    border: "1px solid #3599d1",
    color: "#ffff",
    backgroundColor: "#0176d3",
    marginRight: "8px",
  },
  editTextField: {
    height: "24px",
    fontSize: "12px",
    width: "180px",
    padding: "2px",
    background: "#fff",
  },
  editText: {
    padding: "0",
  },
}));

export default function DefaultHours() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [isEditing, setIsEditing] = useState(false);
  const [selectedFinancialYear, setSelctedFinancialYear] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [yearNew, setYearNew] = useState();
  const [loading, setLoading] = useState(false);
  const [yearlyData, setYearlyData] = useState([]);
  const [yearlyDataInit, setYearlyDataInit] = useState([]);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [financialYearsList, setFinancialYearsList] = useState([]);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleUpdate = () => {
    setLoading(true);
    updateDefaultAvailableHoursAPI(yearlyData).then((response) => {
      if (response.status === 200) {
        setMsgType("success");
        setEmptyErrMsg(true);
        setMsgText("Default hours updated successfully");
        setLoading(false);
        setIsEditing(false);
      }
      if (response.status === 400) {
        setLoading(false);
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText(response.message);
      }
    });
  };

  const handleCancel = () => {
    setIsEditing(false);
    setYearlyData(yearlyDataInit);
  };

  const handleOnYearSelected = (e) => {
    setSelctedFinancialYear(e.target.value);
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onAddYear = () => {
    setLoading(true);
    addYearForDefaultHoursAPI({ year: yearNew }).then((response) => {
      if (response.status === 200) {
        setMsgType("success");
        setEmptyErrMsg(true);
        setMsgText("Year added successfully");
        getFinancialYearsAPI().then((response) => {
          if (response.status === 200) {
            const yearsData = [];
            response.data.forEach((val) => {
              yearsData.push({ id: val, text: val });
            });
            setFinancialYearsList(yearsData);
            setLoading(false);
          }
          if (response.status === 400) {
            setLoading(false);
          }
        });
        setShowDialog(false);
      }
      if (response.status === 400) {
        setLoading(false);
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText(response.message);
      }
    });
  };

  const onAddNew = () => {
    setYearNew(0);
    setShowDialog(true);
  };

  const onChangeHours = (e, month) => {
    const enteredValue =
      e.target.value.toString().trim() === "" ? 0 : e.target.value;
    var validNumber = new RegExp(/^\d*\.?\d*$/);
    if (!validNumber.test(enteredValue)) return false;
    if (Number(enteredValue) > 999) return false;
    const changedData = JSON.parse(JSON.stringify(yearlyData));
    changedData.forEach((val) => {
      if (val.month === month) {
        val.isUpdated = true;
        val.defaultHours = enteredValue.toString().includes(".")
          ? enteredValue
          : Number(enteredValue);
      }
    });
    setYearlyData(changedData);
  };

  const onChangeYear = (e) => {
    const enteredValue =
      e.target.value.toString().trim() === "" ? 0 : e.target.value;
    var validNumber = new RegExp(/^\d*\.?\d*$/);
    if (!validNumber.test(enteredValue)) return false;
    setYearNew(Number(enteredValue));
  };

  useEffect(() => {
    if (selectedFinancialYear && selectedFinancialYear !== "") {
      setLoading(true);
      getDefaultAvailableHoursAPI(selectedFinancialYear).then((response) => {
        if (response.status === 200) {
          setYearlyData(response.data);
          setYearlyDataInit(response.data);
          setLoading(false);
        }
        if (response.status === 400) {
          setLoading(false);
        }
      });
    }
  }, [selectedFinancialYear]);

  useEffect(() => {
    getFinancialYearsAPI().then((response) => {
      if (response.status === 200) {
        const yearsData = [];
        response.data.forEach((val) => {
          yearsData.push({ id: val, text: val });
        });
        setFinancialYearsList(yearsData);
        setLoading(false);
      }
      if (response.status === 400) {
        setLoading(false);
      }
    });
  }, []);

  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.headerContainer}>
          <Grid container>
            <Grid item lg={2}>
              <CustomSelect
                selectedValue={selectedFinancialYear || ""}
                onChangeItem={handleOnYearSelected}
                labelVal="Year"
                id="financialYear"
                items={financialYearsList}
                width="100%"
              />
            </Grid>
            <Grid item lg={4} />
            <Grid item lg={2}>
              <Button
                size="small"
                color="primary"
                variant="contained"
                disableElevation
                className={classes.createBtn}
                onClick={() => onAddNew()}
              >
                Add New Year
              </Button>
            </Grid>
          </Grid>
          {selectedFinancialYear && selectedFinancialYear !== "" && (
            <div>
              {!isEditing && (
                <button className={classes.editBtn} onClick={handleEdit}>
                  Edit
                </button>
              )}
              {isEditing && (
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <button onClick={handleUpdate} className={classes.updateBtn}>
                    Update
                  </button>
                  <button
                    onClick={handleCancel}
                    className={classes.cancelButton}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        {selectedFinancialYear && selectedFinancialYear !== "" && (
          <table className="generalSettingsTable">
            <thead>
              <tr>
                <td>Month</td>
                <td>Default Hours</td>
              </tr>
            </thead>
            <tbody>
              {yearlyData.length === 0 && (
                <tr>
                  <td style={{ textAlign: "center" }} colSpan={2}>
                    No Data
                  </td>
                </tr>
              )}
              {yearlyData.map((item, i) => (
                <tr key={i}>
                  <td>{item.month}</td>
                  <td>
                    {!isEditing ? (
                      item.defaultHours
                    ) : (
                      <FormControl
                        variant="outlined"
                        className={classes.editText}
                      >
                        <OutlinedInput
                          className={classes.editTextField}
                          type="text"
                          onChange={(e) => onChangeHours(e, item.month)}
                          value={item.defaultHours}
                          inputProps={{
                            style: {
                              padding: "0 0 0 2px",
                            },
                          }}
                        />
                      </FormControl>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {showDialog && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="lg"
          aria-labelledby="confirmation-dialog"
          open={showDialog}
        >
          <DialogContent className={classes.addDialog}>
            <div className={classes.popupHeader}>
              <span
                className={classes.closeIconAdd}
                onClick={() => setShowDialog(false)}
              >
                x
              </span>
              <div className={classes.addColumnTitle}>Add New Year</div>
            </div>

            <Grid lg={12} spacing={2} className={classes.formGrid}>
              <div className={classes.fieldTitle}>Year</div>
              <CustomTextField
                selectedValue={yearNew}
                onChangeItem={onChangeYear}
                id="year"
                itemWidth="100%"
              />
            </Grid>
            <div className={classes.popupBtnsAdd}>
              <Button
                className={classes.saveBtn}
                variant="contained"
                color="primary"
                onClick={() => onAddYear()}
                disabled={yearNew === 0}
              >
                Add
              </Button>
              <Button
                variant="outlined"
                className={classes.cancelBtn}
                color="primary"
                onClick={() => setShowDialog(false)}
              >
                Cancel
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
    </>
  );
}
